var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.093 29.856H1.792l7.06-17.431h8.442c2.504 0 4.212 2.535 3.271 4.856l-4.2 10.37a3.53 3.53 0 0 1-3.272 2.205Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.092 17.941H.468L5.63 5.196A7.502 7.502 0 0 1 12.584.51h8.624l-5.162 12.746a7.502 7.502 0 0 1-6.954 4.685Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__a",
    x: -1.252,
    y: -1.21,
    width: 24.18,
    height: 20.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 0.86
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_4373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_24_4373",
    result: "shape"
  })))));
};

export default SvgLogo;